"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.converFilterIntoSQL = void 0;
const types_1 = require("./types");
const valueToSQLFormat = (value, type) => {
    switch (type) {
        case 'NUMBER':
            return value;
        case 'BOOLEAN':
            return value.toLowerCase() === 'true' ? 'TRUE' : 'FALSE';
        case 'STRING':
        default:
            return `'${value}'`;
    }
};
const unaryOperationMapper = {
    set: (field) => {
        return `${field} IS NOT NULL`;
    },
    notSet: (field) => {
        return `${field} IS NULL`;
    },
};
const binaryOperationMapper = {
    equals: (field, values, type) => {
        if ((values === null || values === void 0 ? void 0 : values.length) > 1) {
            return `(${values.map(value => binaryOperationMapper.equals(field, [value])).join(' OR ')})`;
        }
        return `${field} = ${valueToSQLFormat(values[0], type)}`;
    },
    notEquals: (field, values, type) => {
        if ((values === null || values === void 0 ? void 0 : values.length) > 1) {
            return `(${values
                .map(value => binaryOperationMapper.notEquals(field, [value]))
                .join(' OR ')})`;
        }
        return `${field} != ${valueToSQLFormat(values[0], type)}`;
    },
    contains: (field, values) => {
        if ((values === null || values === void 0 ? void 0 : values.length) > 1) {
            return `(${values
                .map(value => binaryOperationMapper.contains(field, [value]))
                .join(' OR ')})`;
        }
        return `${field} LIKE '%${values[0]}%'`;
    },
    notContains: (field, values) => {
        if ((values === null || values === void 0 ? void 0 : values.length) > 1) {
            return `(${values
                .map(value => binaryOperationMapper.notContains(field, [value]))
                .join(' OR ')})`;
        }
        return `${field} NOT LIKE '%${values[0]}%'`;
    },
    gt: (field, values, type) => {
        if ((values === null || values === void 0 ? void 0 : values.length) > 1) {
            return `(${values.map(value => binaryOperationMapper.gt(field, [value])).join(' OR ')})`;
        }
        return `${field} > ${valueToSQLFormat(values[0], type)}`;
    },
    gte: (field, values, type) => {
        if ((values === null || values === void 0 ? void 0 : values.length) > 1) {
            return `(${values.map(value => binaryOperationMapper.gte(field, [value])).join(' OR ')})`;
        }
        return `${field} >= ${valueToSQLFormat(values[0], type)}`;
    },
    lt: (field, values, type) => {
        if ((values === null || values === void 0 ? void 0 : values.length) > 1) {
            return `(${values.map(value => binaryOperationMapper.lt(field, [value])).join(' OR ')})`;
        }
        return `${field} < ${valueToSQLFormat(values[0], type)}`;
    },
    lte: (field, values, type) => {
        if ((values === null || values === void 0 ? void 0 : values.length) > 1) {
            return `(${values.map(value => binaryOperationMapper.lte(field, [value])).join(' OR ')})`;
        }
        return `${field} <= ${valueToSQLFormat(values[0], type)}`;
    },
};
const converFilterIntoSQL = (filter) => {
    if (!filter) {
        return '';
    }
    if ((0, types_1.isOrFilter)(filter)) {
        return `(${filter.or
            .map(statement => (0, exports.converFilterIntoSQL)(statement))
            .filter(Boolean)
            .join(' OR ')})`;
    }
    if ((0, types_1.isAndFilter)(filter)) {
        return `(${filter.and
            .map(statement => (0, exports.converFilterIntoSQL)(statement))
            .filter(Boolean)
            .join(' AND ')})`;
    }
    if (!filter.member) {
        return '';
    }
    if ((0, types_1.isUnaryFilter)(filter)) {
        return unaryOperationMapper[filter.operator](filter.member);
    }
    if (!filter.values || filter.values.length === 0) {
        return '';
    }
    return binaryOperationMapper[filter.operator](filter.member, filter.values, filter.memberType);
};
exports.converFilterIntoSQL = converFilterIntoSQL;
//# sourceMappingURL=converFilterIntoSQL.js.map